import { MediaComponent, MediaImageComponent } from "@common/components/Media/component";
import React from "react";
import { type RenderElementProps, useSelected } from "slate-react";
import { type ImageElement, type LinkElement, type VideoElement } from "../types";
import MediaElement from "./MediaElement";

type Props = Omit<RenderElementProps, "attributes"> & {
  allowVideoFullScreen?: boolean;
  attributes?: any;
  bunnyLibraryId?: string;
  isReadonly?: boolean;
  onDelete?: () => void;
};

const ContentElement = ({ allowVideoFullScreen, attributes, bunnyLibraryId, children, element, onDelete }: Props) => {
  const style: React.CSSProperties = { textAlign: element.align };
  const selected = useSelected();
  switch (element.type) {
    case "a": {
      const a = element as LinkElement;
      return (
        <a {...attributes} href={a.href} target={a.target} style={style}>
          {children}
        </a>
      );
    }
    case "list-item":
      return (
        <li style={style} {...attributes}>
          {children}
        </li>
      );
    case "ul":
      return (
        <ul style={style} {...attributes}>
          {children}
        </ul>
      );
    case "h1":
      return (
        <h1 style={style} {...attributes}>
          {children}
        </h1>
      );
    case "h2":
      return (
        <h2 style={style} {...attributes}>
          {children}
        </h2>
      );
    case "h3":
      return (
        <h3 style={style} {...attributes}>
          {children}
        </h3>
      );
    case "h4":
      return (
        <h4 style={style} {...attributes}>
          {children}
        </h4>
      );
    case "h5":
      return (
        <h5 style={style} {...attributes}>
          {children}
        </h5>
      );
    case "h6":
      return (
        <h6 style={style} {...attributes}>
          {children}
        </h6>
      );
    case "ol":
      return (
        <ol style={style} {...attributes}>
          {children}
        </ol>
      );
    case "p":
      return (
        <p style={style} {...attributes}>
          {children}
        </p>
      );
    case "span": {
      return (
        <span style={style} {...attributes}>
          {children}
        </span>
      );
    }
    case "image": {
      const data = element as ImageElement;

      return (
        <MediaElement attributes={attributes} onDelete={onDelete} isSelected={selected}>
          <MediaImageComponent aspectRatio="auto" url={data.url!} />
        </MediaElement>
      );
    }
    case "video": {
      const data = element as VideoElement;
      return (
        <MediaElement attributes={attributes} onDelete={onDelete} isSelected={selected}>
          <MediaComponent
            allowFullScreen={allowVideoFullScreen}
            aspectRatio={data.aspectRatio}
            bunnyLibraryId={bunnyLibraryId}
            doesNotRequireVideoApp
            sourceId={data.mediaSourceId!}
            sourceKey={data.mediaSourceKey!}
            typeKey="Video"
          />
        </MediaElement>
      );
    }

    default:
      throw new Error(`Unexpected type: ${element["type"]}`);
  }
};
export default ContentElement;
